import React, { useState } from "react";
import { DatePicker, Form, Select, Button, Input, Upload, message  } from "antd";
import { UploadOutlined } from "@ant-design/icons";


export default function AccountPointReport({ handleSubmit, props, stateProp }) {
  let isIEBrowser = /*@cc_on!@*/false || !!document.documentMode;
  const { Option } = Select;
  const { TextArea } = Input;
  const { loadings } = stateProp;
  const [form] = Form.useForm();
  const [fileList, updateFileList] = useState([]);

  const validateMessages = {
    required: "Field is required!",
  };

  const configFile = {
    // fileList,
    // disabled: fileList.length == 1 ? true : false,
    method: 'get',
    listType: 'picture',
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png";

      if (!isJpgOrPng) {
        message.error("You can only upload JPG/PNG file!");
        return isJpgOrPng;
      }

      const isLt2M = file.size / 2000 / 2000 < 2;
      if (!isLt2M) {
        message.error("Image must smaller than 2MB!");
        return isLt2M;
      }

    },
    onChange(info) {
      try {

        let list = [...info.fileList];
        list = list.slice(-1);

        list = list.map(file => {
          if (file.response) {
            // Component will show file.url as link
            file.url = file.response.url;
          }
          return file;
        });

        updateFileList(list.filter(file => !!file.status));

      } catch (error) {
        console.log(error)
      }

    },
    onRemove(file) {
      return new Promise((resolve, reject) => {
        resolve(true);

      });
    },
    fileList
  };


  if (stateProp.submited) {
    form.resetFields();
  }
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `

          .ant-upload-list-item{
            height: auto !important;
          }
          .ant-picker-input > input {
            height: 40px;
          }
          .ant-picker-large {
            width: 70%;
          }
        `,
        }}></style>
      <div className="container container--1000">
        <div className="text--center mart--xxl marb--xxl">
          <div
            className="action_status"
            style={{
              lineHeight: 1.7,
              textAlign: "center",
              fontSize: "18px",
              marginBottom: "45px",
            }}></div>
        </div>

        <Form
          form={form}
          name="missing_point"
          size="large"
          validateMessages={validateMessages}
          onFinish={handleSubmit}
          scrollToFirstError>
          <div className="form__row">
            <div className="col col--50">
              <label className="label" htmlFor="confirmation_no">
                {props.langData.label_confirmation_no}
              </label>
              <Form.Item
                name="confirmation_no"
                id="confirmation_no"
                rules={[{ required: true }, { max: 200 }]}>
                <Input size="middle" maxLength={200} />
              </Form.Item>
            </div>
          </div>

          <div className="form__row">
            <div className="col col--50">
              <label className="label" htmlFor="guest_name">
                {props.langData.label_guest_name}
              </label>
              <Form.Item
                name="guest_name"
                id="guest_name"
                rules={[{ required: true }, { max: 200 }]}>
                <Input size="middle" maxLength={200} />
              </Form.Item>
            </div>
          </div>

          <div className="form__row">
            <div className="col col--50">
              <label className="label" htmlFor="hotel_location">
                {props.langData.label_list_hotel}
              </label>

              <Form.Item
                id="hotel_location"
                name="reward_location"
                rules={[{ required: true }]}>
                <Select
                  showSearch
                  style={{ width: "100%" }}
                  placeholder={props.langData.placeholder_hotel_selected}
                  optionFilterProp="children"
                  bordered={true}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }>
                  {stateProp.rewardLocationItemData?.length > 0 && (
                    <>
                      {stateProp.rewardLocationItemData.map((obj, index) => {
                        return (
                          <Option
                            value={`${obj.code}-${obj.name}`}
                            key={obj.code}>
                            {obj.name}
                          </Option>
                        );
                      })}
                    </>
                  )}
                </Select>
              </Form.Item>
            </div>
          </div>

          <div className="form__row">
            <div className="col col--50 datepicker-single-container">
              <label className="label" htmlFor="checkin_date">
                {props.langData.label_check_in_date}
              </label>
              <Form.Item
                id="check_in_date"
                className=""
                name="check_in_date"
                rules={[{ required: true }]}>
                <DatePicker />
              </Form.Item>
            </div>

            <div className="col col--50 padl--xxl datepicker-single2-container">
              <label className="label" htmlFor="check_out_date">
                {props.langData.label_check_out_date}
              </label>
              <Form.Item
                id="check_out_date"
                className=""
                name="check_out_date"
                rules={[{ required: true }]}>
                <DatePicker size="large" />
              </Form.Item>
            </div>
          </div>

          {!isIEBrowser && (
            <div className="form__row">
              <div className="col col--50">
                <label className="label" htmlFor="file_url">
                  {props.langData.label_file_upload}
                </label>
                <Form.Item id="file_url" className="" name="file_url">
                  <Upload {...configFile}>
                    <Button size="middle" icon={<UploadOutlined />}>Click to Upload</Button>
                  </Upload>
                </Form.Item>
              </div>
            </div>
          )}

          <div className="form__row">
            <label className="label" htmlFor="comment">
              {props.langData.label_comment}
            </label>
            <Form.Item
              id="comment"
              className=""
              name="message"
              rules={[{ required: true }, { max: 500 }]}>
              <TextArea maxLength={500} autoSize={{ minRows: 3, maxRows: 5 }} />
            </Form.Item>
          </div>

          <div className="form__row text--center">
            <Button
              type="primary"
              htmlType="submit"
              loading={loadings[0]}
              size="large">
              {props.langData.btn_label}
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}
